export default {
  markAllAsRead: 'Alle als gelesen markieren',
};
